define('threadsRouter',[
  'app',
  'require',
  'module',
  'marionette',
  'underscore',
  'backbone',
  'itemPagesNameMixin'
], function (
  App,
  require,
  module,
  Marionette,
  _,
  Backbone,
  ItemPagesNameMixin
) {
  'use strict';

  var ThreadsRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'threads': 'showList',
      'threads/:from': 'showList',
      'threads/:from/:folder': 'showList'
    }
  });

  var API = {
    showList: function (from, folder) {
      require([
        'threadsView',
        'contentShowController'
      ], function (ThreadsView,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          this.threadsView = new ThreadsView({
            from: from,
            folder: folder
          });
          App.regions.getRegion('main').currentView.getRegion('content').show(this.threadsView);
          App.execute('set:active:nav:item', ItemPagesNameMixin.THREADS);
        });
      });
    }
  };

  App.on('before:start', function () {
    new ThreadsRouter({
      controller: API
    });
  });

  module.exports = ThreadsRouter;
});

